import { render, staticRenderFns } from "./last-wins-card.vue?vue&type=template&id=0834f172&scoped=true&"
import script from "./last-wins-card.vue?vue&type=script&lang=js&"
export * from "./last-wins-card.vue?vue&type=script&lang=js&"
import style0 from "./last-wins-card.vue?vue&type=style&index=0&id=0834f172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834f172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0834f172')) {
      api.createRecord('0834f172', component.options)
    } else {
      api.reload('0834f172', component.options)
    }
    module.hot.accept("./last-wins-card.vue?vue&type=template&id=0834f172&scoped=true&", function () {
      api.rerender('0834f172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/last-wins-card.vue"
export default component.exports